module.exports = __webpack_public_path__ + "static/media/bg-home.88e0535b.svg";